module.exports = __webpack_public_path__ + "static/media/favorite.9274a7f3.svg";